import React, { useState } from 'react';
import { useUser } from '../../contexts/UserContext';

export function Contact() {
  const { user, openLogin } = useUser();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [emailError, setEmailError] = useState('');

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const strictEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const parts = email.split('@');
    
    if (parts.length !== 2) return false;
    if (!strictEmailRegex.test(email)) return false;
    
    const domain = parts[1];
    if (!domainRegex.test(domain)) return false;
    
    if (/[^a-zA-Z0-9.-]/.test(domain)) return false;
    
    const tld = domain.split('.').pop();
    if (tld.length < 2 || tld.length > 6) return false;
    
    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (name === 'email') {
      setEmailError('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!user) {
      openLogin();
      return;
    }
    if (!isValidEmail(formData.email)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    // TODO: Implement form submission logic
    console.log('Form submitted:', formData);
  };

  const isFormValid = formData.name && formData.message && isValidEmail(formData.email);

  return (
    <section id="contact" className="py-20 bg-[#F6F8FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-[#24292F] sm:text-4xl">
            Get in Touch
          </h2>
          <p className="mt-4 text-lg text-[#57606A] max-w-2xl mx-auto">
            Have questions about FirstCommit? We're here to help you get started.
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-[#24292F] mb-1.5">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full h-11 rounded-lg border-[#D0D7DE] bg-[#F6F8FA] text-[#24292F] shadow-sm focus:border-[#0969DA] focus:ring-[#0969DA] px-4 text-base transition-colors duration-200"
                  placeholder="Your name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-[#24292F] mb-1.5">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className={`w-full h-11 rounded-lg border-[#D0D7DE] bg-[#F6F8FA] text-[#24292F] shadow-sm focus:border-[#0969DA] focus:ring-[#0969DA] px-4 text-base transition-colors duration-200 ${
                    emailError ? 'border-[#FF7B72]' : ''
                  }`}
                  placeholder="you@example.com"
                />
                {emailError && (
                  <p className="mt-1.5 text-sm text-[#FF7B72]">{emailError}</p>
                )}
              </div>
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-[#24292F] mb-1.5">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                rows={4}
                className="w-full rounded-lg border-[#D0D7DE] bg-[#F6F8FA] text-[#24292F] shadow-sm focus:border-[#0969DA] focus:ring-[#0969DA] px-4 py-3 text-base resize-none transition-colors duration-200"
                placeholder="Tell us what you need..."
              />
            </div>

            <div className="pt-4">
              <button
                type="submit"
                disabled={user ? !isFormValid : false}
                className="w-full h-11 bg-gray-900 text-white rounded-xl hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-base font-medium"
              >
                {user ? 'Send Message' : 'Sign in to Send Message'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
} 